import React from 'react';
import Tittle from '../Components/Tittle';
import allFilms from '../Components/allFilms';
import short2 from '../img/films/short2.jpg';
import short3 from '../img/films/short3.jpg';
import short1 from '../img/films/short4.jpg';

const FIlmsPage = () => {
    return (
        <div >
            <div className="b-title">
                <Tittle title={'My Short FIlms'} span={'My Short FIlms'} />
            </div>
            <div className="BlogsPage">
                {
                    allFilms.map((blog) => {
                        return <div className="blog" key={blog.id}>
                            <div className="blog-content">
                                <img src={blog.image} alt="" />
                                <a href={blog.link} className="blog-link">
                                    {blog.title}
                                </a>
                            </div>
                        </div>
                    })
                }
            </div>

            <div className="p-3 container mt-3">
                <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src={short3} class="d-block w-100" alt="..." />
                        </div>
                        <div class="carousel-item">
                            <img src={short2} class="d-block w-100" alt="..." />
                        </div>
                        <div class="carousel-item">
                            <img src={short1} class="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

        </div>
    );
};

export default FIlmsPage;